import { CollectibleElastic_Schema } from "@/services/collectibles/elastic";
import { getCollectibleElasticParams } from "@/services/collectibles/elastic/collectiblesElasticHelpers";
import { hasCollectibleElastic, type PublicCollectionItem } from "@/services/collection/item/public";
import type { Ref } from "vue";

export function usePublicCollectionItemParameters(item: Ref<PublicCollectionItem | undefined>) {
  const params = computed(() => {
    const i = item.value;

    if (i === undefined) {
      return [];
    }

    if (hasCollectibleElastic(i)) {
      // Since PublicCollectionItem is not in zod, we must parse it here :(
      // @todo drop when PCI will have it's own schema.
      const collectible = CollectibleElastic_Schema.parse(i.collectibleElastic);
      return getCollectibleElasticParams(collectible);
    } else {
      return i.catalogueItemParams.map((param) => ({ name: param.label, value: param.value }));
    }
  });

  return params;
}
